module.exports = __webpack_public_path__ + "img/test.b480c190.jpg";